import DeleteIcon from '@material-ui/icons/DeleteOutlined'
import Tooltip from 'elements/tooltip/Tooltip'
import { IconButton } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import type { MouseEventHandler } from 'react'
import { useComponentActionStyles } from '../../projectSections/sections/design/systems/tabs/common/styles'

export const RemoveComponentButton = ({
  onClick,
  'data-testid': dataTestId,
}: {
  onClick: MouseEventHandler
  'data-testid'?: string
}) => {
  const classes = useComponentActionStyles()
  const translate = useTranslate()
  return (
    <Tooltip title={translate('Remove')}>
      <IconButton className={classes.button} onClick={onClick} data-testid={dataTestId}>
        {<DeleteIcon className={classes.icon} />}
      </IconButton>
    </Tooltip>
  )
}
